export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const CREATE_POST_FAIL = "CREATE_POST_FAIL";
export const CREATE_POST_FAIL_INAPPROPRIATE = "CREATE_POST_FAIL_INAPPROPRIATE";
export const CREATE_POST_FAIL_DETECT_CATEGORY =
  "CREATE_POST_FAIL_DETECT_CATEGORY";
export const CREATE_POST_FAIL_CATEGORY_MISMATCH =
  "CREATE_POST_FAIL_CATEGORY_MISMATCH";
export const CLEAR_CREATE_POST_FAIL = "CLEAR_CREATE_POST_FAIL";
export const CONFIRM_POST_SUCCESS = "CONFIRM_POST_SUCCESS";
export const CONFIRM_POST_FAIL = "CONFIRM_POST_FAIL";
export const REJECT_POST_SUCCESS = "REJECT_POST_SUCCESS";
export const REJECT_POST_FAIL = "REJECT_POST_FAIL";
export const GET_POST_SUCCESS = "GET_POST_SUCCESS";
export const GET_POST_FAIL = "GET_POST_FAIL";
export const GET_OWN_POST_SUCCESS = "GET_OWN_POST_SUCCESS";
export const GET_OWN_POST_FAIL = "GET_OWN_POST_FAIL";
export const GET_POSTS_SUCCESS = "GET_POSTS_SUCCESS";
export const GET_POSTS_FAIL = "GET_POSTS_FAIL";
export const CLEAR_POST = "CLEAR_POST";
export const CLEAR_POSTS = "CLEAR_POSTS";
export const CLEAR_COMMUNITY_POSTS = "CLEAR_COMMUNITY_POSTS";
export const GET_COMMUNITY_POSTS_SUCCESS = "GET_COMMUNITY_POSTS_SUCCESS";
export const GET_COMMUNITY_POSTS_FAIL = "GET_COMMUNITY_POSTS_FAIL";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_FAIL = "DELETE_POST_FAIL";
export const UPDATE_POST_REQUEST = "UPDATE_POST_REQUEST";
export const UPDATE_POST_SUCCESS = "UPDATE_POST_SUCCESS";
export const UPDATE_POST_FAIL = "UPDATE_POST_FAIL";
export const LIKE_POST_SUCCESS = "LIKE_POST_SUCCESS";
export const LIKE_POST_FAIL = "LIKE_POST_FAIL";
export const UNLIKE_POST_SUCCESS = "UNLIKE_POST_SUCCESS";
export const UNLIKE_POST_FAIL = "UNLIKE_POST_FAIL";
export const SAVE_POST_SUCCESS = "SAVE_POST_SUCCESS";
export const SAVE_POST_FAIL = "SAVE_POST_FAIL";
export const UNSAVE_POST_SUCCESS = "UNSAVE_POST_SUCCESS";
export const UNSAVE_POST_FAIL = "UNSAVE_POST_FAIL";
export const GET_SAVED_POSTS_SUCCESS = "GET_SAVED_POSTS_SUCCESS";
export const GET_SAVED_POSTS_FAIL = "GET_SAVED_POSTS_FAIL";
export const GET_PRIVATE_POSTS_SUCCESS = "GET_PRIVATE_POSTS_SUCCESS";
export const GET_PRIVATE_POSTS_FAIL = "GET_PRIVATE_POSTS_FAIL";
export const ADD_COMMENT_FAIL = "ADD_COMMENT_FAIL";
export const ADD_COMMENT_FAIL_INAPPROPRIATE = "ADD_COMMENT_FAIL_INAPPROPRIATE";
export const CLEAR_COMMENT_FAIL = "CLEAR_COMMENT_FAIL";
export const GET_PUBLIC_POSTS_SUCCESS = "GET_PUBLIC_POSTS_SUCCESS";
export const GET_PUBLIC_POSTS_FAIL = "GET_PUBLIC_POSTS_FAIL";
export const GET_FOLLOWING_USERS_POSTS_SUCCESS =
  "GET_FOLLOWING_USERS_POSTS_SUCCESS";
export const GET_FOLLOWING_USERS_POSTS_FAIL = "GET_FOLLOWING_USERS_POSTS_FAIL";
export const GET_SKILLS_FEED_POSTS_SUCCESS = "GET_SKILLS_FEED_POSTS_SUCCESS";
export const GET_SKILLS_FEED_POSTS_FAIL = "GET_SKILLS_FEED_POSTS_FAIL";
export const GET_FOLLOWING_POSTS_SUCCESS = "GET_FOLLOWING_POSTS_SUCCESS";
export const GET_FOLLOWING_POSTS_FAIL = "GET_FOLLOWING_POSTS_FAIL";
export const CLEAR_FOLLOWING_POSTS = "CLEAR_FOLLOWING_POSTS";
export const INCREASE_SAVED_BY_COUNT = "INCREASE_SAVED_BY_COUNT";
export const DECREASE_SAVED_BY_COUNT = "DECREASE_SAVED_BY_COUNT";
export const REPORT_POST_SUCCESS = "REPORT_POST_SUCCESS";
export const REPORT_POST_FAIL = "REPORT_POST_FAIL";
